import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { UiDashBoardCard, UiBackgroundImg } from './DashBoardCard.style';


/**
 * 班級課程卡牌
 */

export const DashBoardCard = ({
  className,
  onClick,
  disabled = false,
  src,
  title,
  groupName,
  sessionInterval,
  isActive,
  hostName,
  defaultImg
}) => {
  const [isSrc, setIsSrc] = useState(false);
  useEffect(() => {
    (async () => {
      await fetch(src)
        .then(response => {
          if (response.status === 404) {
            setIsSrc(false);
          } else {
            setIsSrc(true);
          }
        })
        .catch(() => {
          setIsSrc(false);
        });
    })();
  }, [setIsSrc]);

  const onClickHandle = () => {
    disabled || (onClick && onClick());
  };
  return (
    <UiDashBoardCard className={className} onClick={onClickHandle}
      tabIndex={0} >
      <div className="image">
        <img src={isSrc ? src : defaultImg} alt="session" data-testid="Img" />
      </div>
      <div className="info">
        <div className="info_item">
          <div className="title">{title}</div>
          <div className="time">
            {sessionInterval}
            {isActive || <span>已結束</span>}
          </div>
        </div>
        <div className="bottom_info">

          <div className="badge">{groupName}</div>
          <div className="name">
            {hostName} 老師
          </div>
        </div>
      </div>
    </UiDashBoardCard>
  );
};

DashBoardCard.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  src: PropTypes.any,
  title: PropTypes.string,
  groupName: PropTypes.string,
  sessionInterval: PropTypes.string,
  isActive: PropTypes.bool,
  hostName: PropTypes.string,
  defaultImg: PropTypes.any
};
